import { render, staticRenderFns } from "./CreateVariantModal.vue?vue&type=template&id=3e0c044b"
import script from "./CreateVariantModal.vue?vue&type=script&lang=ts"
export * from "./CreateVariantModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports